var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEarth = function SvgEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500.5 500.5",
    height: 500.5,
    width: 500.5,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "invis earthShards",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    "data-id": 0,
    d: "M104.65 311.696l10.353-9.202 13.738 7.088z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 1,
    d: "M128.74 309.582L158.3 320.8l-14.436-16.754z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 2,
    d: "M105.895 334.7l1.922 35.421-10.33-12.928z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 3,
    d: "M128.74 309.582l-20.923 60.537-3.167-58.423z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 4,
    d: "M128.74 309.582L158.3 320.8l-50.482 49.32z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 5,
    d: "M136.39 390.465l-.126-48.136-28.447 27.79z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 6,
    d: "M136.264 342.329l39.485-15.753-17.45-5.776z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 7,
    d: "M175.749 326.576l-39.36 63.89-.125-48.137z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 8,
    d: "M175.749 326.576l28.612 27.51-46.731 1.903z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 9,
    d: "M157.63 355.99l62.055-2.528-9.99 45.99z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 10,
    d: "M136.39 390.465l73.304 8.988-52.064-43.464z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 11,
    d: "M209.694 399.453l-73.304-8.99 36.919 30.476z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 12,
    d: "M153.913 432.39l28.884 28.344 9.907-51.249z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 13,
    d: "M153.881 447.945l28.916 12.789-28.884-28.344z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 14,
    d: "M153.881 447.945l15.306 27.714 13.61-14.925z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 15,
    d: "M169.187 475.66l26.13 21.695-12.52-36.621z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 16,
    d: "M76.407 310.536l28.243 1.16.689 12.721z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 17,
    d: "M282.794 225.716l63.292 15.496-19.474-22.842z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 18,
    d: "M340.703 206.956l22.652-8.642-1.96 21.737z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 19,
    d: "M363.355 198.314l28.433 19.302-23.312 1.994z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 20,
    d: "M296.203 198.478l-18.925 19.876-10.753-12.663z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 21,
    d: "M296.203 198.478l24.8 2.573-43.725 17.303z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 22,
    d: "M304.416 170.908l-8.215 27.57-7.369-17.335z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 23,
    d: "M319.705 122.335l65.724-27.9-38.396-14.969z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 24,
    d: "M346.086 241.212l33.289-3.492-23.68-7.74z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 25,
    d: "M430.56 232.348l-18.144 69.674 44.313-37.2z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 26,
    d: "M401.807 339.874l-13.834 44.525 18.022-16.033z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 27,
    d: "M348.245 429.064l8.695-42.103 15.874 35.752z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 28,
    d: "M332.78 379.416l24.16 7.545-8.695 42.103z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 29,
    d: "M340.175 349.206l16.765 37.755-24.16-7.545z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 30,
    d: "M340.175 349.206l47.798 35.193-15.159 38.314z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 31,
    d: "M366.73 329.97l21.243 54.429-60.975-44.895z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 32,
    d: "M366.73 329.97l35.077 9.904-13.834 44.525z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 33,
    d: "M437.54 296.811l-108.534 22.505 72.801 20.558z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 34,
    d: "M329.004 319.316l37.726 10.653-39.732 9.535z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 35,
    d: "M311.032 148.703l9.97 52.348-24.8-2.573z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 36,
    d: "M321.003 201.05l27.837-44.077-41.808-29.259z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 37,
    d: "M343.816 222.012l-8.894-43-11.323 17.926z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 38,
    d: "M334.922 179.013l28.433 19.301-22.654 8.642z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 39,
    d: "M348.84 156.973l31.283 31.168-45.201-9.128z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 40,
    d: "M361.176 312.647l51.24-10.627 18.144-69.672z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 41,
    d: "M391.788 217.616l38.772 14.732-51.185 5.372z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 42,
    d: "M346.086 241.212l15.09 71.433 69.384-80.297z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 43,
    d: "M329.004 319.316l17.082-78.104 15.09 71.433z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 44,
    d: "M329.004 319.316l-46.21-93.6 63.292 15.496z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 45,
    d: "M253.325 267.892l9.918 38.851 45.845-27.77z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 46,
    d: "M253.325 267.892l29.469-42.176 26.293 53.256z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 47,
    d: "M263.241 306.743l21.15 14.22 24.696-41.99z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 48,
    d: "M284.391 320.963l39.515-11.977-14.82-30.014z",
    fill: "#ff66c6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 49,
    d: "M334.922 179.013l105.991 21.406-49.125 17.197z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 50,
    d: "M385.429 94.435l-36.587 62.538-41.808-29.259z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 51,
    d: "M446.654 99.026l-4.145 41.023-57.08-45.613z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 52,
    d: "M348.84 156.973l53.662-9.695-17.073-52.843z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 53,
    d: "M442.507 140.049l-62.384 48.093 60.79 12.28z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 54,
    d: "M442.507 140.049l-93.665 16.924 31.28 31.168z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 55,
    d: "M406.089 95.985l8.884-34.297 31.68 37.338z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 56,
    d: "M442.507 140.049l47.532 43.175-49.126 17.197z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 57,
    d: "M446.654 99.026l43.387 84.198-47.532-43.175z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 58,
    d: "M473.76 248.76l26.74-6.412-2.184 51.368z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 59,
    d: "M473.76 248.76l16.279-65.536 10.461 59.124z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 60,
    d: "M391.788 217.616l81.973 31.146 16.278-65.538z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 61,
    d: "M184.8 9.167l38.607 4.13-50.798 23.785z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 62,
    d: "M202.341 23.126l-16.933 23.486-12.801-9.528z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 63,
    d: "M223.407 13.298L275.15 3.145 184.8 9.167z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 64,
    d: "M223.407 13.298l69.89 17.859L275.15 3.145z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 65,
    d: "M260.614 70.134l16.623-43.08-53.83-13.756z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 66,
    d: "M212.066 52.779l6.508-22.657-17.227 7.086z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 67,
    d: "M260.614 70.134l10.321-26.75-.253 20.568z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 68,
    d: "M193.863 116.155l66.751-46.023-37.207-56.834z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 69,
    d: "M224.837 109.746l24.907-27.58 10.22 12.444z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 70,
    d: "M193.863 116.155l7.728 19.33 59.023-65.353z",
    fill: "#ba66ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 71,
    d: "M58.56 287.34l11.647 3.014 4.849-15.868z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 72,
    d: "M70.968 298.5l18.123 12.557-12.686-.52z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 73,
    d: "M52.655 285.81l36.434 25.247-5.44-17.222z",
    fill: "#ff7566"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 74,
    d: "M26.257 283.165L70.968 298.5l-18.313-12.69z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 75,
    d: "M8.408 246.747l44.247 39.063-26.398-2.645z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 76,
    d: "M8.408 246.747l42.297 2.93-5.163 29.853z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 77,
    d: "M57.05 222.689l24.973 3.903 16.607 40.144z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 78,
    d: "M120.738 203.877l24.127-35.87 12.732 25.705z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 79,
    d: "M110.862 164.915l37.744-25.324-8.283-20.395z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 80,
    d: "M169.716 170.265l-58.854-5.35 52.657-35.331z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 81,
    d: "M110.862 164.915l9.876 38.962 24.127-35.87z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 82,
    d: "M127.59 99.95l52.137-8.663-12.318 30.335z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 83,
    d: "M125.412 82.36l34.376-27.256-13.954-8.86z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 84,
    d: "M125.412 82.36l54.315 8.927-19.939-36.18z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 85,
    d: "M125.412 82.36l2.178 17.59 52.137-8.663z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 86,
    d: "M110.862 164.915l-45.347 21.77 56.744 23.192z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 87,
    d: "M90.327 246.665l-24.812-59.98 56.744 23.192z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 88,
    d: "M57.05 222.689l-6.345 26.989 29.158-2.821z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 89,
    d: "M65.515 186.685L57.05 222.69l24.974 3.903z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 90,
    d: "M16.09 166.483L0 243.178l8.41 3.57z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 91,
    d: "M8.408 246.747l57.107-60.062-49.425-20.202z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 92,
    d: "M8.408 246.747l42.297 2.93 14.81-62.992z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 93,
    d: "M98.113 131.93L16.09 166.484l94.772-1.568z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 94,
    d: "M120.34 41.413L60.08 91.364l67.51 8.586z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 95,
    d: "M60.08 91.364l-43.99 75.119 82.023-34.552z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 96,
    d: "M60.08 91.364l38.033 40.567 29.477-31.98z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 97,
    d: "M385.429 94.435l57.078 45.614-40.005 7.229z",
    fill: "#ffe066"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 98,
    d: "M110.862 164.915l-94.772 1.568 49.425 20.202z",
    fill: "#ffc266"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 99,
    d: "M153.913 432.39l19.397-11.451-36.92-30.474z",
    fill: "#ff7566"
  }))));
};
export default SvgEarth;